










































































import Filter from '@/models/filter.model';
import FilterRadioButton from "./FilterRadioButton.vue";
import FilterCheckbox from "./FilterCheckbox.vue";
import FilterGroup from '@/models/filter-group.model';
import FilterGroupFilterCombi from '@/classes/filter-group-filter-combi.model';
import Translations from '@/models/translations.model';
import PredefinedFilterItem from '@/models/predefined-filter-item.model';

export default {
  name: "FilterOverlay",
  components: {
    FilterRadioButton,
    FilterCheckbox,
  },
  props: {
    filters: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      filterGroupElements: null,
    };
  },
  computed: {
    totalProductsLength(): number {
      return this.$store.getters.sortedProducts.length;
    },
    translations(): Translations {
      return this.$store.state.translations;
    },
    predefinedFilterItems(): Array<PredefinedFilterItem> {
      return this.$store.state.predefinedFilterItems;
    },
    totalFilters(): Array<FilterGroup> {
      return this.filters;
    }
  },
  methods: {
    handleCheckboxChange(filterGroup: FilterGroup, filter: Filter) {
      const filterGroupFilterCombi = new FilterGroupFilterCombi(filterGroup, filter);

      if (this.$store.getters.isSelectedFilter(filter)) {
        this.$store.dispatch("unselectProductFilter", filterGroupFilterCombi);
      } else {
        this.$store.dispatch("selectProductFilter", filterGroupFilterCombi);
      }
    },
    handleRadioButtonChange(filterGroup: FilterGroup, filter: Filter) {
      const filterGroupFilterCombi = new FilterGroupFilterCombi(filterGroup, filter);
      // radio buttons don't trigger a change event when they are de-selected
      // so only the new filter is selected and the action will check if the type of
      // the filterGroup is 'single' (radio buttons) and will then
      // remove all other selected filters from this group
      this.$store.dispatch("selectProductFilter", filterGroupFilterCombi);
    },
    resetFilterGroup(filtergroup: FilterGroup) {
      this.$store.dispatch("unselectProductFilterGroup", filtergroup);
    },
    resetAllFilters() {
      this.$store.dispatch("resetProductFilters");
    },
    toggleFilterOverlay() {
      this.$el.instance.toggle();
    },
    hideFilterOverlay() {
      this.$el.instance.setVisibility(false);
    },
    initOffCanvas() {
      Miele.ModuleLoader.createModuleInstance("elements/objects/offcanvas", this.$el);
    },
    initFilterGroups() {
      this.filterGroupElements = this.$el.querySelectorAll(".flt-group-2col");

      for (let i = 0, iLen = this.filterGroupElements.length; i < iLen; i++) {
        Miele.ModuleLoader.createModuleInstance("elements/filter/group-2col", this.filterGroupElements[i]);
      }
    },
    bindFootnotesClickHandler() {
      document.addEventListener('click', this.footnotesClickEventHandler);
    },
    unbindFootnotesClickHandler() {
      document.removeEventListener('click', this.footnotesClickEventHandler);
    },
    footnotesClickEventHandler(e: MouseEvent) {
      const target = e.target as HTMLElement;

      if (!target.matches('a.link-footnote')) {
        return;
      }

      this.hideFilterOverlay();
    },
  },
  mounted() {
    this.initOffCanvas();
    this.initFilterGroups();
    this.bindFootnotesClickHandler();
  },
  destroyed() {
    this.unbindFootnotesClickHandler();
  },
};
